webpackJsonp([8,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 08/02/2018.
	 */
	//js
	var Shared = __webpack_require__(10);
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(3);
	var log = __webpack_require__(5)();
	
	//Styles
	__webpack_require__(767);
	
	// Partial views
	var htmlReq = __webpack_require__(466);
	
	$(function () {
	  Shared.shouldSetUpCreditsDialog = false;
	  Shared.init();
	  TermsOfUsePage.init();
	});
	
	var TermsOfUsePage = {};
	
	(function (TermsOfUsePage) {
	  TermsOfUsePage.init = function () {
	    setUpHtmlPartial();
	  };
	
	  function setUpHtmlPartial() {
	    var htmlRequire = "./" + LanguageManager.getCurrentLocale() + "/terms-of-use.html";
	    var htmlPartial = void 0;
	
	    var defaultRequire = "./default/terms-of-use.html";
	
	    if (htmlReq.keys().includes(htmlRequire)) {
	      htmlPartial = htmlReq(htmlRequire);
	      $("#terms-of-use-content").html(htmlPartial);
	    } else if (htmlReq.keys().includes(defaultRequire)) {
	      htmlPartial = htmlReq(defaultRequire);
	      $("#terms-of-use-content").html(htmlPartial);
	    } else {
	      log.error("Couldn't find html partial [%s] in known html partial list: %o", htmlRequire, htmlReq.keys());
	      utils.redirect("/");
	    }
	  }
	})(TermsOfUsePage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./default/terms-of-use.html": 787,
		"./nl-BE/terms-of-use.html": 791
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 466;


/***/ }),

/***/ 767:
47,

/***/ 787:
/***/ (function(module, exports) {

	module.exports = "<div class=\"legal-content-wrapper\">\n  <h1 class=\"page-title mb-5\">Circonopoly – algemene voorwaarden</h1>\n\n  <p>Circonopoly is een product gerealiseerd door de POM West-Vlaanderen in samenwerking met de sectorfondsen Cobot en\n    Plastiq, met steun van Vlaanderen Circulair, hierna ‘de partners’ genoemd.</p>\n  <p>De doelstelling is om via een <b>educatief spel</b> de jongeren onder te dompelen in de wereld van circulair\n    ondernemerschap. Het zet jongeren aan om na te denken over <b>duurzaam materiaalgebruik</b> en\n    <b>consumptiegedrag</b> en prikkelt hun <b>ondernemingszin</b>. Het project wilt hiermee de brug slaan tussen drie\n    pijlers van de POM; het aanjagen van innovatie in speerpuntsectoren als nieuwe materialen (Fabrieken voor de\n    Toekomst), het stimuleren van ondernemerschap en het informeren en enthousiasmeren van toekomstige werkzoekenden\n    voor jobs en opleidingen in deze speerpuntsectoren</p>\n  <p>Om toegang te krijgen tot het spelen van het spel Circonopoly, dient u zich te registreren als gebruiker. U kan uw\n    persoonsgegevens ten allen tijde nalezen en wijzigingen via het menu ‘mijn gegevens’. U vindt hier eveneens een\n    overzicht van de door u bewaarde bestanden. U kan zich ten slotte ten allen tijde laten verwijderen als gebruiker\n    via het menu ‘mijn account’ of door een mail te sturen naar <a\n      href=\"mailto:info@circonopoly.be\">info@circonopoly.be</a> . De POM West-Vlaanderen en haar partners verbinden zich\n    ertoe om binnen de 30 dagen gevolg te geven aan uw vraag tot het verwijderen van al uw persoonsgegevens uit de\n    website.</p>\n  <p>Als gebruiker van Circonopoly hebt u toegang tot de webapplicatie waarmee het spel gespeeld kan worden. U kan in de\n    webapplicatie nieuwe sessies aanmaken, sessies opvragen en resultaten van de spelers bekijken. De resultaten kunnen\n    gedownload worden in pdf formaat en worden doorgemaild.</p>\n  <p>De POM West-Vlaanderen is niet aansprakelijk voor schade die het gevolg is van het door de abonnee niet naleven van\n    de AVG of andere wet- of regelgeving, inclusief de algemene voorwaarden. De gebruiker vrijwaart de POM\n    West-Vlaanderen voor aanspraken van derden op grond van zulke schade. De vrijwaring geldt niet alleen voor de schade\n    die derden hebben geleden (materieel maar immaterieel) maar ook voor de kosten die de POM West-Vlaanderen zou moeten\n    maken in de juridische procedure en eventuele boetes die aan derden werden opgelegd.</p>\n\n</div>\n";

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

	module.exports = "<div class=\"legal-content-wrapper\">\n  <h1 class=\"page-title mb-5\">Circonopoly – algemene voorwaarden</h1>\n\n  <p>Circonopoly is een product gerealiseerd door de POM West-Vlaanderen in samenwerking met de sectorfondsen Cobot en\n    Plastiq, met steun van Vlaanderen Circulair, hierna ‘de partners’ genoemd.</p>\n  <p>De doelstelling is om via een <b>educatief spel</b> de jongeren onder te dompelen in de wereld van circulair\n    ondernemerschap. Het zet jongeren aan om na te denken over <b>duurzaam materiaalgebruik</b> en\n    <b>consumptiegedrag</b> en prikkelt hun <b>ondernemingszin</b>. Het project wilt hiermee de brug slaan tussen drie\n    pijlers van de POM; het aanjagen van innovatie in speerpuntsectoren als nieuwe materialen (Fabrieken voor de\n    Toekomst), het stimuleren van ondernemerschap en het informeren en enthousiasmeren van toekomstige werkzoekenden\n    voor jobs en opleidingen in deze speerpuntsectoren</p>\n  <p>Om toegang te krijgen tot het spelen van het spel Circonopoly, dient u zich te registreren als gebruiker. U kan uw\n    persoonsgegevens ten allen tijde nalezen en wijzigingen via het menu ‘profiel aanpassen’. U vindt hier eveneens een\n    overzicht van de door u bewaarde bestanden. U kan zich ten slotte ten allen tijde laten verwijderen als gebruiker\n    door een mail te sturen naar\n    <a href=\"mailto:dpo@pomwvl.be\">dpo@pomwvl.be</a>. De POM West-Vlaanderen en haar partners verbinden zich\n    ertoe om binnen de 30 dagen gevolg te geven aan uw vraag tot het verwijderen van al uw persoonsgegevens uit de\n    website.</p>\n  <p>Als gebruiker van Circonopoly hebt u toegang tot de webapplicatie waarmee het spel gespeeld kan worden. U kan in de\n    webapplicatie nieuwe sessies aanmaken, sessies opvragen en resultaten van de spelers bekijken. De resultaten kunnen\n    gedownload worden in pdf formaat en worden doorgemaild.</p>\n  <p>De POM West-Vlaanderen is niet aansprakelijk voor schade die het gevolg is van het door de abonnee niet naleven van\n    de AVG of andere wet- of regelgeving, inclusief de algemene voorwaarden. De gebruiker vrijwaart de POM\n    West-Vlaanderen voor aanspraken van derden op grond van zulke schade. De vrijwaring geldt niet alleen voor de schade\n    die derden hebben geleden (materieel maar immaterieel) maar ook voor de kosten die de POM West-Vlaanderen zou moeten\n    maken in de juridische procedure en eventuele boetes die aan derden werden opgelegd.</p>\n\n  <p>\n    <a href=\"/disclaimer\" target=\"_blank\">Disclaimer</a>: Algemene voorwaarden met betrekking tot online communicatie\n    van Circonopoly van POM West Vlaanderen<br/>\n    <a href=\"/privacy-policy\" target=\"_blank\">Privacy policy</a>: Privacybeleid van Circonopoly van POM West\n    Vlaanderen<br/>\n    <a href=\"/cookie-policy\" target=\"_blank\">Cookie policy</a>: Cookie beleid van Circonopoly van POM West\n    Vlaanderen<br/>\n  </p>\n\n</div>\n";

/***/ })

});


// WEBPACK FOOTER //
// js/legal/terms-of-use.2a477aa5c8fe8a2f86df.js